import useMediaQuery from "@mui/material/useMediaQuery";

const PssLogo = () => {
  let sm = useMediaQuery("(max-width:600px)");

  return (
    <img
      src="/assets/navbar/pss-logo.png"
      alt="pss-logo"
      height={sm ? 70 : 90}
      width={sm ? 100 : 150}
    />
  );
};

export default PssLogo;
